"use client";

import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
export default function TaxiIntro() {
  return <section id="localtaxiintro" data-nav="light" className="bg-background text-foreground py-16 md:py-20">
      <div className="max-w-[1136px] mx-auto px-6">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-3xl">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-block w-8 h-[2px] bg-primary" aria-hidden="true" />
            <span className="text-xs uppercase tracking-wider font-semibold text-primary">
              Stadt- &amp; Resort-Transfers
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-accent-foreground mb-6 leading-tight">
            Private Taxifahrten in ganz Hurghada
          </h2>

          <div className="space-y-4 text-base sm:text-lg text-muted-foreground leading-relaxed">
            <p>
              Buchen Sie private Punkt-zu-Punkt-Taxifahrten zwischen Hotels,
              Resorts, Stadtteilen, Einkaufszentren, Restaurants und lokalen
              Sehenswürdigkeiten. Egal, ob Sie zum Abendessen in die Hurghada
              Marina fahren, die Senzo Mall besuchen oder beliebte lokale{" "}
              <Link to="/DestinationsDEPage" className="font-medium text-accent-foreground underline decoration-primary underline-offset-4 hover:text-primary transition-colors">
                Reiseziele
              </Link>{" "}
              erkunden – unsere Fahrer bieten Ihnen direkten Tür-zu-Tür-Transport
              zu im Voraus vereinbarten Festpreisen.
            </p>

            <p>
              Bitte beachten Sie, dass planmäßige{" "}
              <Link to="/HomeDEPage" className="font-medium text-accent-foreground underline decoration-primary underline-offset-4 hover:text-primary transition-colors">
                Flughafentransfers
              </Link>{" "}
              auf einer separaten Seite abgewickelt werden, während sich dieser
              Service speziell auf lokale Fahrten innerhalb der Stadt und
              zwischen Resorts konzentriert. Für ganztägige Reiserouten oder
              regionale Fernfahrten können Sie zudem unseren{" "}
              <Link to="/PrivateDriverHireDEPage" className="font-medium text-accent-foreground underline decoration-primary underline-offset-4 hover:text-primary transition-colors">
                Privaten Fahrerservice
              </Link>{" "}
              reservieren.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}